import React, { useEffect, useState } from 'react';
import {
  Calculator,
  Calendar,
  CreditCard,
  Settings,
  Smile,
  User,
  Search,
  FileText
} from 'lucide-react';

import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
} from '../../ui/command';
import { Button } from '../../ui/button';

/**
 * Búsqueda global (Command Palette)
 * @param {{ onNavigate: (path: string) => void }} props
 */
const GlobalSearch = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const down = (e) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  const runCommand = (command) => {
    setOpen(false);
    onNavigate(command);
  };

  return (
    <>
      <Button
        variant="outline"
        className="relative h-9 w-9 p-0 xl:h-10 xl:w-60 xl:justify-start xl:px-3 xl:py-2 text-muted-foreground bg-white/50 dark:bg-slate-900/50"
        onClick={() => setOpen(true)}
      >
        <Search className="h-4 w-4 xl:mr-2" />
        <span className="hidden xl:inline-flex">Buscar...</span>
        <kbd className="pointer-events-none absolute right-1.5 top-2 hidden h-6 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium opacity-100 xl:flex">
          <span className="text-xs">⌘</span>K
        </kbd>
      </Button>

      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Escribe un comando o busca..." />
        <CommandList>
          <CommandEmpty>No se encontraron resultados.</CommandEmpty>
          <CommandGroup heading="Sugerencias">
            <CommandItem onSelect={() => runCommand('/clientes')}>
              <User className="mr-2 h-4 w-4" />
              <span>Personas</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand('/conversiones/simulaciones')}>
              <Calculator className="mr-2 h-4 w-4" />
              <span>Simulaciones</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand('/conversiones/contrataciones')}>
              <FileText className="mr-2 h-4 w-4" />
              <span>Contrataciones</span>
            </CommandItem>
          </CommandGroup>
          <CommandSeparator />
          <CommandGroup heading="Navegación">
            <CommandItem onSelect={() => runCommand('/admin/familias')}>
              <Settings className="mr-2 h-4 w-4" />
              <span>Familias de Seguros</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand('/admin/planes')}>
              <CreditCard className="mr-2 h-4 w-4" />
              <span>Planes y Tarifas</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand('/payments')}>
              <CreditCard className="mr-2 h-4 w-4" />
              <span>Historial de Pagos</span>
            </CommandItem>
          </CommandGroup>
        </CommandList>
      </CommandDialog>
    </>
  );
};

export default GlobalSearch;
